import { Database, MessagesSquare, MapPin, BarChart3 } from "lucide-react";
import { Container, Reveal, SectionHeader } from "./common";
import { LogoMark } from "./Logo";

const products = [
    {
        icon: Database,
        name: "CRM",
        desc: "Manage leads, contacts, accounts, opportunities and your entire sales process.",
    },
    {
        icon: MessagesSquare,
        name: "Engage",
        desc: "Email, WhatsApp and customer engagement — powered by live CRM data.",
    },
    {
        icon: MapPin,
        name: "Field Sales",
        desc: "Manage visits, routes and field teams with GPS check-ins and daily plans.",
    },
    {
        icon: BarChart3,
        name: "Analytics",
        desc: "Understand performance across people, pipeline and revenue — then decide faster.",
    },
];

const Ecosystem = () => (
    <section id="ecosystem" data-testid="product-ecosystem-section" className="bg-white py-20 lg:py-28">
        <Container>
            <SectionHeader
                eyebrow="Product Ecosystem"
                title="One platform. Your entire growth operation."
                sub="Every Kryvo product shares the same customer record — so nothing falls through the cracks between teams."
            />
            <div className="relative mt-16">
                {/* connecting line (desktop) */}
                <div className="absolute left-[12%] right-[12%] top-1/2 hidden h-px bg-gradient-to-r from-transparent via-[#16A34A]/40 to-transparent lg:block" aria-hidden="true" />
                <div className="relative grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    {products.map((p, i) => (
                        <Reveal key={p.name} delay={i * 0.08}>
                            <article className="group relative h-full rounded-2xl border border-[#E5E7EB] bg-white p-6 text-center shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:border-[#16A34A]/30 hover:shadow-xl">
                                <div className="relative mx-auto flex h-14 w-14 items-center justify-center rounded-2xl border border-[#16A34A]/15 bg-[#F0FDF4] transition-colors group-hover:bg-[#16A34A]">
                                    <p.icon className="h-6 w-6 text-[#16A34A] transition-colors group-hover:text-white" />
                                    <span className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-[#111827] text-[8px] font-bold text-white">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                </div>
                                <h3 className="mt-4 font-display text-lg font-bold text-[#111827]">{p.name}</h3>
                                <p className="mt-2 text-[13px] leading-relaxed text-[#64748B]">{p.desc}</p>
                            </article>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.2}>
                    <div className="mx-auto mt-10 flex w-fit items-center gap-3 rounded-full border border-[#E5E7EB] bg-[#F7FEF9] py-2.5 pl-3 pr-5 shadow-sm">
                        <LogoMark size={26} />
                        <span className="text-sm font-semibold text-[#111827]">
                            Connected by one shared customer record
                        </span>
                    </div>
                </Reveal>
            </div>
        </Container>
    </section>
);

export default Ecosystem;
